module.exports = __webpack_public_path__ + "img/diploma_4.a3c19332.jpg";